import dialogsSlice from "./dialogs.slice";

export * from "./hooks";
export * from "./dialogs.slice";
export * from "./types";
export * from "./dialogs.saga";

export default dialogsSlice.reducer;
